import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  FormControlLabel,
  Checkbox,
  makeStyles,
  // Tooltip,
} from '@material-ui/core';
import Label from './label';
import { updateSearchItems } from '../../../../store/search/searchItemsSlice';
import { useKanniKensaku } from '../../../../containers/search/kanniKensaku/KanniKensakuContext';

const useStyles = makeStyles((theme) => ({
  checkBox: {
    marginRight: 1,
    marginLeft: 0,
    '& span': {
      fontSize: 13,
    },
  },
  checkBoxMain: {
    '&.Mui-checked': {
      color: theme.palette.primaryColor,
    },
    '& .MuiSvgIcon-root': { fontSize: 18 },
  },
  checkBoxWrap: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 4,
    marginBottom: 4,
  },
  infoIcon: {
    color: '#D83420',
    fontSize: 20,
  },
}));

function SortCheckBox() {
  const {
    searchConditions,
    setSearchConditions,
    isAvoidSharedCustomer,
  } = useKanniKensaku();

  const classes = useStyles();
  const dispatch = useDispatch();

  // 更新用
  const [count, setCount] = useState(0);

  useEffect(() => {
    // グローバルステート(簡易検索条件)の更新
    dispatch(updateSearchItems(searchConditions));
  }, [count]);

  const CheckChange = (name, checkStatus) => {
    if (checkStatus) {
      checkStatus = Number(checkStatus);
    } else {
      checkStatus = null;
    }

    switch (name) {
      case 'isCalledAndNotMailed':
        setSearchConditions({ ...searchConditions, isCalledAndNotMailed: checkStatus });
        break;
      case 'searchType4':
        setSearchConditions({ ...searchConditions, searchType4: checkStatus });
        break;
      case 'isSendShare':
        setSearchConditions({ ...searchConditions, isSendShare: checkStatus });
        break;
      case 'isWebHistoryExist':
        setSearchConditions({ ...searchConditions, isWebHistoryExist: checkStatus });
        break;
      case 'isDirectExist':
        setSearchConditions({ ...searchConditions, isDirectExist: checkStatus });
        break;
      case 'isCallablePhoneNumberExist':
        setSearchConditions({ ...searchConditions, isCallablePhoneNumberExist: checkStatus });
        break;
      case 'isSendableMailExist':
        setSearchConditions({ ...searchConditions, isSendableMailExist: checkStatus });
        break;
      case 'isLineExist':
        // LINE有を更新する際、LINE無を同時にnullにする (排他制御)
        setSearchConditions({
          ...searchConditions,
          isLineExist: checkStatus,
          isLineNotExist: checkStatus === 1 ? null : searchConditions.isLineNotExist,
        });
        break;
      case 'isLineNotExist':
        // LINE無を更新する際、LINE有を同時にnullにする (排他制御)
        setSearchConditions({
          ...searchConditions,
          isLineNotExist: checkStatus,
          isLineExist: checkStatus === 1 ? null : searchConditions.isLineExist,
        });
        break;
      default:
        break;
    }
    setCount(count + 1);
  };

  const handleChange = (event) => {
    CheckChange(event.target.name, event.target.checked);
  };

  const sortCheckList = [
    {
      key: 'isSendShare',
      title: '共有顧客',
      state: !isAvoidSharedCustomer && searchConditions.isSendShare,
      disabled: isAvoidSharedCustomer,
    },
    {
      key: 'isCalledAndNotMailed',
      title: 'TEL済/未Mail',
      state: searchConditions.isCalledAndNotMailed,
    },
    {
      key: 'isDirectExist',
      title: '指示有',
      state: searchConditions.isDirectExist,
    },
    {
      key: 'isWebHistoryExist',
      title: 'Web履歴有',
      state: searchConditions.isWebHistoryExist,
    },
    {
      key: 'isCallablePhoneNumberExist',
      title: 'TEL有',
      state: searchConditions.isCallablePhoneNumberExist,
    },
    {
      key: 'isSendableMailExist',
      title: 'Mail有',
      state: searchConditions.isSendableMailExist,
    },
    {
      key: 'isLineExist',
      title: 'LINE有',
      state: searchConditions.isLineExist,
    },
    {
      key: 'isLineNotExist',
      title: 'LINE無',
      state: searchConditions.isLineNotExist,
    },
  ];

  const createCheckBox = sortCheckList.map((data) => {
    return (
      <div key={data.key} className={classes.checkBoxWrap}>
        <FormControlLabel
          className={classes.checkBox}
          size="small"
          control={
            <Checkbox
              checked={Boolean(data.state)}
              onChange={handleChange}
              name={data.key}
              color="primary"
              className={classes.checkBoxMain}
              disabled={data.disabled}
            />
          }
          label={<Label data={data} />}
        />
      </div>
    );
  });

  return createCheckBox;
}
export default SortCheckBox;
